
<div class="container">
  <div class="row">
    <div class="col">
      <p>Optional: download, edit, and re-upload a spreadsheet containing additional asset details.</p>
    </div>
  </div>
  <div class="row">
    <div class="col"> </div>
    <div class="col"><a class="btn btn-primary btn-block" [downloadFile]="'/api/sites/export-assets/' + siteId" *ngIf="!isLocked"><span class="oi oi-cloud-download"></span> Export Assets</a><a class="btn btn-primary btn-block disabled" href="#" *ngIf="isLocked"><span class="oi oi-cloud-download"></span> Export Assets</a></div>
    <div class="col"><a class="btn btn-primary btn-block" [uploadFileTo]="'/api/sites/import-assets/' + siteId" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" [title]="'Import Assets'" *ngIf="!isLocked"><span class="oi oi-cloud-upload"></span> Upload Assets</a><a class="btn btn-primary btn-block disabled" href="#" *ngIf="isLocked"><span class="oi oi-cloud-upload"></span> Upload Assets</a></div>
    <div class="col"> </div>
  </div>
</div>